<template>
  <div>
    <!--
    <b-alert variant="warning" show>
      Las compras realizadas entre el viernes 29 de diciembre de 2023 y el 14 de enero de 2024 se despacharán a partir del 15  de enero de 2024
    </b-alert>
    -->
    <cart ref="cart" @change="$emit('change', $event);" :viewType="viewType" />
    <div class="d-flex d-md-none m-2">
      <div
        class="rounded py-2 px-4 d-flex justify-content-between flex-fill subtotal-line"
        style="background: #f1f1f1;"
      >
        <div>Subtotal</div>
        <div>${{ subtotal }}</div>
      </div>
      <b-button
        size="sm"
        class="ml-3"
        style="background: #e8661a; border:none; line-height: 2rem; font-size: 1em;"
        
        @click="$refs.cart.saveData()"
        >Siguiente</b-button
      >
    </div>
  </div>
</template>
<script>
import Cart from "@/components/Cart.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    Cart
  },
  data: function() {
    return {
      subtotal: 0
    }
  },
  mounted(){
    this.calcSubtotal();
  },
  computed:{
    viewType(){
      const w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        if (w > 768){
          return "Table"
        }else{
          return "List"
        }
    },
    ...mapState({
      cartItems: state => state.cart.cartItems,
      isLogged: state => state.user.isLogged
    }),
    ...mapGetters({ cart: "countCartItems" })
  },
  methods:{
    calcSubtotal: function() {
      

      let result = 0;
      if(this.$refs.cart){
        
        this.cartItems.forEach(
          function(element) {
            result += this.$refs.cart.getBookCost(element.id, element.type) * element.quantity;
          }.bind(this)
        );

      }
      setTimeout(function(){
        this.calcSubtotal();
      }.bind(this), 500)
       
      this.subtotal = result;
    },
  }

};
</script>
